import { EnrollmentLight } from '../../lib/types/models/enrollment/enrollment-light'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getSimilarParentEnrollments(id: number): Promise<EnrollmentLight[]> {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getSimilarParentEnrollments.url, { id }))
    .get<EnrollmentLight[]>()
}
